import plansModel from '../../models/plans';
import Store from '../../store/main';
import paymentInternal from '../payment/paymentInternal';
import app from '../../app';
import { getPricePerUser } from './helpers';
import constants from '../../helpers/constants';

export default class Payment {
  constructor() {
    this.usersSelection = [
      {
        id: 1,
        count: 1,
        disabled: false,
        text: `1 ${__('one_user_locale')}`,
      },
      {
        id: 5,
        count: 5,
        disabled: false,
        text: `5 ${__('users_locale')}`,
      },
      {
        id: 10,
        count: 10,
        disabled: false,
        text: `10 ${__('users_locale')}`,
      },
      {
        id: 15,
        count: 15,
        disabled: false,
        text: `15 ${__('users_locale')}`,
      },
      {
        id: 20,
        count: 20,
        disabled: false,
        text: `20 ${__('users_locale')}`,
      },
      {
        id: 25,
        count: 25,
        disabled: false,
        text: `25 ${__('users_locale')}`,
      },
      {
        id: 30,
        count: 30,
        disabled: false,
        text: `30 ${__('users_locale')}`,
      },
      {
        id: 35,
        count: 35,
        disabled: false,
        text: `35 ${__('users_locale')}`,
      },
      {
        id: 40,
        count: 40,
        disabled: false,
        text: `40+ ${__('users_locale')}`,
      },
      // {
      //   id: 45,
      //   count: 45,
      //   disabled: false,
      //   text: `45 ${__('users_locale')}`,
      // },
      // {
      //   id: 50,
      //   count: 50,
      //   disabled: false,
      //   text: `50 ${__('users_locale')}`,
      // },
    ];
  }

  getCurrentSubscription() {
    const currentPlanId = plansModel.getPlanId();
    const currentSubsription = user.paymentPlans.find(paymentPlan => paymentPlan.id === currentPlanId);

    return currentSubsription;
  }

  getNextNumberOfUsersForPaymentPopup() {
    const maxWithoutSale = constants.MAX_USER_COUNT_TO_INVITE_WITHOUT_SALE;
    const userCount = plansModel.isOverSubscription() ? 0 : Math.min(plansModel.getUserCount(), maxWithoutSale);
    const realResources = Math.min(Store.getters['resourcesModel/getAllRealResources'].length, maxWithoutSale);
    const counts = [userCount, realResources, 1];
    const maxCount = counts.reduce((max, number) => (number > max ? number : max));
    const nextCount = this.usersSelection.find(item => item.count >= maxCount);

    return nextCount;
  }

  getNextNumberOfUsersForPaymentPage() {
    const maxWithoutSale = constants.MAX_USER_COUNT_TO_INVITE_WITHOUT_SALE;
    const realUsers = Store.getters['resourcesModel/getAllRealResources'];

    let nextCount = 0;

    // plansModel.isTrial() || plansModel.isRefunded() || plansModel.isTerminated()
    if (plansModel.isTrial()) {
      if (realUsers.length > maxWithoutSale) {
        nextCount = this.usersSelection.find(obj => obj.count === maxWithoutSale);
      } else if (realUsers.length < 5) {
        nextCount = this.usersSelection.find(item => item.count === 5);
      } else {
        nextCount = this.usersSelection.find(item => item.count >= realUsers.length);
      }

      const disabledCounts = realUsers.length === 1 ? -1 : Math.min(realUsers.length, maxWithoutSale);

      this.usersSelection = this.disableUnavailableSelection(disabledCounts);
    } else {
      const currentUserCount = plansModel.isOverSubscription() ? realUsers.length : plansModel.getUserCount();
      const limit = Math.min(currentUserCount, maxWithoutSale);

      nextCount = this.usersSelection.find(obj => obj.count >= currentUserCount) || this.usersSelection[1];

      if (currentUserCount > maxWithoutSale) {
        nextCount = this.usersSelection.find(obj => obj.count === maxWithoutSale);
      }

      this.usersSelection = this.disableUnavailableSelection(limit);
    }

    return nextCount;
  }

  disableUnavailableSelection(num, disabledFirst = false) {
    return this.usersSelection.map(obj => ({
      ...obj,
      disabled: +obj.count < +num || (obj.count === 1 && disabledFirst),
    }));
  }

  getPlansWithCurrentPriceByUserCount(userCount, isAnnual) {
    const annual = isAnnual ? 1 : 0;
    const plans = user.paymentPlans.filter(item => {
      if (item.id !== 17) {
        return item;
      }
    });

    return plans.map(item => {
      const isCurrentPlan = item.id === plansModel.getPlanId();
      const isCurrentUserCount = userCount === plansModel.getUserCount();
      const isCurrentPeriod = annual === plansModel.isAnnual();

      const isCurrentPaymentPlan = isCurrentPlan && isCurrentUserCount && isCurrentPeriod;

      const plan = {
        ...item,
        price: this.getPriceByPlanAndUserCount(item, userCount, isAnnual),
        isCurrentPaymentPlan,
      };

      return plan;
    });
  }

  getPriceByPlanAndUserCount(plan, userCount, isAnnual) {
    const priceData = isAnnual ? plan.annual_price_usd_json : plan.month_price_usd_json;
    const price = getPricePerUser(priceData, userCount);

    return price;
  }

  buyPlan(plan, userCount, isAnnual) {
    if (plansModel.isCanNotBeUpdatedWithoutSales()) {
      app.trigger('messageUsForm:show', 'upgrade-via-sale-contact-us-form');

      return false;
    }

    const newPlan = {
      planId: plan.plan_id,
      userCount,
    };
    const newPeriod = isAnnual ? 'year' : 'month';

    Store.dispatch('globalPopup/close');
    userExtAnalytics.log('pricing_upgrade_now_clicked', { type: isAnnual ? 'annually' : 'monthly', count: userCount, plan: plan.name });
    paymentInternal.handlers.showPopup(null, {
      newPlan,
      newPeriod,
      subjectView: 'default',
    });
  }

  upgradePlan(plan, userCount, isAnnual) {
    if (plansModel.isOverSubscription()) {
      this.buyPlan(plan, userCount, isAnnual);

      return;
    }

    userExtAnalytics.log('pricing_upgrade_now_clicked', { type: isAnnual ? 'annually' : 'monthly', count: userCount, plan: plan.name });

    Store.dispatch('globalPopup/close');
    Store.commit('paymentClient/showUpgradePopup', {
      show: true,
      mode: 'change-plan',
      newPlan: plan,
      userCount,
      isAnnual,
    });

    // Store.dispatch('globalPopup/close');
    // Store.dispatch('globalPopup/show', {
    //   type: 'upgradePlan',
    //   title: 'upgrade_plan_popup_title',
    //   mode: 'upgrade-plan',
    //   currentPlan: userPlan,
    //   newPlan: plan,
    //   userCount: countData.count,
    //   isAnnual,
    // });
  }
}
